import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.sync()
  }

  toggle() {
    this.openValue = !this.openValue
    this.sync()
  }

  sync() {
    this.contentTarget.classList.toggle("hidden", !this.openValue)
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.openValue ? "rotate(180deg)" : ""
    }
  }
}
